export interface IBitrix24LineUpdate {
  id?: string
  line: string
  description: string
  responsible_user: number
  smart_call: boolean
  b24_manager_time: boolean
  start_time: string
  end_time: string
  auto_lead: boolean
  chat: boolean
}

export const Bitrix24LineUpdateInitValues = {
  id: '',
  line: '',
  description: '',
  responsible_user: 1,
  smart_call: false,
  b24_manager_time: false,
  start_time: '09:00',
  end_time: '18:00',
  auto_lead: false,
  chat: false,
}

export interface IBitrix24LineNew {
  id_newline?: string
  line_newline: string
  description_newline: string
  responsible_user_newline: number
  smart_call_newline: boolean
  b24_manager_time_newline: boolean
  start_time_newline: string
  end_time_newline: string
  auto_lead_newline: boolean
  chat_newline: boolean
}

export const Bitrix24LineNewInitValues = {
  id_newline: '',
  line_newline: '',
  description_newline: '',
  responsible_user_newline: 1,
  smart_call_newline: false,
  b24_manager_time_newline: false,
  start_time_newline: '09:00',
  end_time_newline: '18:00',
  auto_lead_newline: false,
  chat_newline: false,
}

export interface IAutoLeadUpdate {
  auto_lead: boolean
}

export const AutoLeadUpdateInitValues = {
  auto_lead: false,
}

export const Bitrix24UserInServiceInitValues = {
  id: '',
  is_active: false,
  bitrix24_user_id: '',
  internal_number: '',
  external_number: '',
  fullname: '',
  bitrix24_manager_time: false,
  smart_call: false,
  smart_call_time: {
    mon_is_active: false,
    mon_start_time: '09:00',
    mon_end_time: '18:00',
    tue_is_active: false,
    tue_start_time: '09:00',
    tue_end_time: '18:00',
    wed_is_active: false,
    wed_start_time: '09:00',
    wed_end_time: '18:00',
    thu_is_active: false,
    thu_start_time: '09:00',
    thu_end_time: '18:00',
    fri_is_active: false,
    fri_start_time: '09:00',
    fri_end_time: '18:00',
    sat_is_active: false,
    sat_start_time: '09:00',
    sat_end_time: '18:00',
    sun_is_active: false,
    sun_start_time: '09:00',
    sun_end_time: '18:00',
  },
  chat: false,
  auto_answer: false,
  multiple_registration: false,
}

export interface IAMISettingsCreate {
  host: string
  username: string
  secret: string
}

export const AMISettingsInitValues = {
  host: '',
  username: '',
  secret: '',
}

export interface IRegionSettingsCreate {
  region: 'BY' | 'RU' | 'DE'
  time_zone: string
  is_auto_mode: boolean
}

export const RegionSettingsInitValues = {
  region: 'BY',
  time_zone: '',
  is_auto_mode: '',
}

export interface IOtherSettingsCreate {
  crm_domain: string
  id_project?: string
  api_key?: string
  users_in_service: boolean
  record_url: string
  ignore_trunks: string
  mode_is_cloud: 'CLOUD' | 'LOCAL' | null
  bitrix24_client_id: string | null
  bitrix24_client_secret: string | null
}

export const OtherSettingsInitValues: IOtherSettingsCreate = {
  crm_domain: '',
  id_project: '',
  api_key: '',
  users_in_service: false,
  record_url: '',
  ignore_trunks: '',
  mode_is_cloud: null,
  bitrix24_client_id: null,
  bitrix24_client_secret: null,
}

export interface IYeastarSettingsCreate {
  api_is_active: boolean
  mp3_is_active: boolean
  host: string
  username: string
  secret: string
  ftp_path: string
}

export const YeastarSettingsInitValues = {
  api_is_active: false,
  mp3_is_active: false,
  host: '',
  username: '',
  secret: '',
  ftp_path: '/ftp_media/mmc/autorecords/',
}

export interface IOutgoingCallModeUpdate {
  outgoing_call_mode: string
}

export const OutgoingCallModeInitValues = {
  outgoing_call_mode: 'Unsorted',
}
